module.exports = __webpack_public_path__ + "static/media/money-pounds-five.a0188943.svg";